module.exports = __webpack_public_path__ + "static/media/Construction.768dbd80.svg";